<portal-activity-indicator (clicked)="menu.trigger()"/>
<portal-activity-menu #menu></portal-activity-menu>

